const OTP_SIGN_IN_RESEND_COUNT = 'otp-resend-count';
const OTP_SIGN_IN_RESEND_AVAILABLE_TIME = 'otp-resend-available-time';
const OTP_MAX_RESEND_COUNT = 4;
const OTP_RESEND_COOL_DOWN_MINS = 10;
const OTP_ONE_MINUTE_DURATION = 60000;

export const isAllowedToResendOtp = (): boolean => {
  const resendAvailableTime = localStorage.getItem(
    OTP_SIGN_IN_RESEND_AVAILABLE_TIME,
  );
  const now = new Date();

  if (resendAvailableTime != null && new Date(resendAvailableTime) > now) {
    //there is a time block. Don't allow resending OTP
    return false;
  } else {
    const attemptCount = parseInt(
      localStorage.getItem(OTP_SIGN_IN_RESEND_COUNT) ?? '0',
    );
    if (attemptCount < OTP_MAX_RESEND_COUNT) {
      localStorage.setItem(
        OTP_SIGN_IN_RESEND_COUNT,
        (attemptCount + 1).toString(),
      );
      if (localStorage.getItem(OTP_SIGN_IN_RESEND_AVAILABLE_TIME) ?? false) {
        localStorage.removeItem(OTP_SIGN_IN_RESEND_AVAILABLE_TIME);
      }
      return true;
    } else {
      //user exceeded maximum allowed OTP request. set a cool off period to avoid more OTP calls.
      localStorage.removeItem(OTP_SIGN_IN_RESEND_COUNT);
      const coolDownTime = new Date();
      coolDownTime.setTime(
        coolDownTime.getTime() +
          OTP_RESEND_COOL_DOWN_MINS * OTP_ONE_MINUTE_DURATION,
      );
      localStorage.setItem(
        OTP_SIGN_IN_RESEND_AVAILABLE_TIME,
        coolDownTime.toString(),
      );
      return false;
    }
  }
};
